import isString from 'lodash/isString'
import omit from 'lodash/omit'
import { readCookie } from '@purecarslabs/signal-utils/cookies'
import { parseIntNoNaN } from '@purecarslabs/signal-utils/parseIntFloat'
import { FORM_FIELD_ACCEPT_TERMS } from '@app-src/containers/FormContent/constants'
import { LEAD_CATEGORY_MAP, PCUID_COOKIE, PCSID_COOKIE } from './constants'
import { NativeLeadType, LeadContactType, LeadContextType } from './types'

/**
 * cookLeadForBackend
 * @description converts the data manipulated by the form application to the native lead type for POSTing to backend
 * @param {String} accountId - the account ID
 * @param {String} categoryName - the category name (passed into lead form API)
 * @param {String} countryCode - the country code (passed into lead form API)
 * @param {Object} leadContact - the lead contact (which was generated by Formik from the form UI contents)
 * @param {Object} leadContext - the lead context (which can be optionally provided by the lead form API, and is further filled out here)
 * @return {Object} - the NativeLeadType object generated from the above inputs
 */
export function cookLeadForBackend(
  accountId: string,
  categoryName: string,
  countryCode: string | undefined,
  leadContact: LeadContactType,
  leadContext?: LeadContextType
): NativeLeadType {
  return {
    contact: {
      ...omit(leadContact, [FORM_FIELD_ACCEPT_TERMS]),
      country: countryCode || 'us',
      preferredMethodOfContact: isString(leadContact.preferredMethodOfContact)
        ? parseIntNoNaN(leadContact.preferredMethodOfContact as string)
        : leadContact.preferredMethodOfContact
    },
    context: {
      accountId,
      category: LEAD_CATEGORY_MAP[categoryName.toLowerCase()] || 0,
      sendEmailLead: true,
      sourceId: readCookie(PCSID_COOKIE) ?? '',
      pcuid: readCookie(PCUID_COOKIE) ?? '',
      ...(leadContext || {})
    },
    provider: {
      email: 'support@purecars.com',
      name: 'PureCars',
      service: 'PureCars',
      url: 'https://purecars.com'
    }
  }
}
